/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Table_No_DataInputs */

const en_common_table_no_data = /** @type {(inputs: Common_Table_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data`)
};

const zh_common_table_no_data = /** @type {(inputs: Common_Table_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无数据`)
};

/**
* | output |
* | --- |
* | "No data" |
*
* @param {Common_Table_No_DataInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_table_no_data = /** @type {((inputs?: Common_Table_No_DataInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Table_No_DataInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_table_no_data(inputs)
	return zh_common_table_no_data(inputs)
});
export { common_table_no_data as "common.table.no_data" }